import Stack from "@mui/material/Stack";
import { PatientProfile, Task } from "src/api/types";
import Messaging from "src/components/Messaging";
import PrescriptionRequest from "src/components/PrescriptionRequest";
import PrescriptionProvider from "src/context/PrescriptionProvider";
import SubscriptionsProvider from "src/context/SubscriptionsProvider/SubscriptionsProvider";
import TitrationProvider from "src/context/TitrationProvider";
import TaskWrapper from "src/wrappers/TaskWrapper";

interface Props {
  task: Task;
  onSuccess: () => Promise<void>;
  patient: PatientProfile;
}

const PrescriptionRequestTask = ({ task, onSuccess, patient }: Props) => {
  return (
    <SubscriptionsProvider patientId={task.patient_id}>
      <PrescriptionProvider prescriptionId={task.resource_id}>
        <TitrationProvider>
          <Stack gap={2}>
            <TaskWrapper task={task}>
              <PrescriptionRequest
                onSuccess={onSuccess}
                patientRegion={patient.profile.region}
              />
            </TaskWrapper>
            <Messaging allowMessaging={false} patientId={patient.id} />
          </Stack>
        </TitrationProvider>
      </PrescriptionProvider>
    </SubscriptionsProvider>
  );
};

export default PrescriptionRequestTask;
